"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.defaultFooterElements = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/footer.css");
const FooterItem_js_1 = require("./FooterItem.js");
const FooterSeparator_js_1 = require("./FooterSeparator.js");
const FooterList_js_1 = require("./FooterList.js");
const footerTranslations = {
    cookies: 'Cookies',
    legalNotices: 'Legal notices',
    privacy: 'Privacy',
    termsOfService: 'Terms of service',
    termsOfUse: 'Terms of use',
};
exports.defaultFooterElements = [
    {
        key: 'copyright',
        title: `© ${new Date().getFullYear()} Bentley Systems, Incorporated`,
    },
    {
        key: 'termsOfService',
        title: footerTranslations.termsOfService,
        url: 'https://connect-agreementportal.bentley.com/AgreementApp/Home/Eula/view/readonly/BentleyConnect',
    },
    {
        key: 'privacy',
        title: footerTranslations.privacy,
        url: 'https://www.bentley.com/en/privacy-policy',
    },
    {
        key: 'termsOfUse',
        title: footerTranslations.termsOfUse,
        url: 'https://www.bentley.com/en/terms-of-use-and-select-online-agreement',
    },
    {
        key: 'cookies',
        title: footerTranslations.cookies,
        url: 'https://www.bentley.com/en/cookie-policy',
    },
    {
        key: 'legalNotices',
        title: footerTranslations.legalNotices,
        url: 'https://connect.bentley.com/Legal',
    },
];
/**
 * Footer element with all needed legal and info links.
 * Be sure to place it manually at the bottom of your page.
 * You can use position 'absolute' with relative body or set the height of the content and place footer at the end.
 * @example <caption>Appending custom element after default elements</caption>
 * <Footer customElements={[{title: 'Bentley', url: 'https://www.bentley.com/'}]} />
 * @example <caption>Returning only custom elements</caption>
 * <Footer customElements={() => newFooterElements)} />
 * @example <caption>Filtering out a specific element</caption>
 * <Footer customElements={(defaultElements) => defaultElements.filter(({ key }) => key !== 'privacy' )} />
 * @example <caption>Changing a url</caption>
 * <Footer customElements={(defaultElements) => defaultElements.map(element => ({ ...element, url: element.key === 'privacy' ? customPrivacyUrl : element.url }))} />
 */
exports.Footer = Object.assign((props) => {
    const { children, customElements, translatedTitles, className, ...rest } = props;
    (0, index_js_1.useTheme)();
    const titles = { ...footerTranslations, ...translatedTitles };
    const translatedElements = exports.defaultFooterElements.map((element) => {
        if (element.key && titles.hasOwnProperty(element.key)) {
            const key = element.key;
            return {
                ...element,
                title: titles[key],
            };
        }
        return element;
    });
    let elements = translatedElements;
    if (customElements) {
        elements =
            typeof customElements === 'function'
                ? customElements(translatedElements)
                : [...translatedElements, ...customElements];
    }
    return (React.createElement("footer", { className: (0, classnames_1.default)('iui-legal-footer', className), ...rest }, children ? (children) : (React.createElement(FooterList_js_1.FooterList, null, elements.map((element, index) => {
        return (React.createElement(React.Fragment, { key: element.key || `${element.title}-${index}` },
            index > 0 && React.createElement(FooterSeparator_js_1.FooterSeparator, null),
            React.createElement(FooterItem_js_1.FooterItem, null, element.url ? (React.createElement("a", { href: element.url, target: '_blank', rel: 'noreferrer' }, element.title)) : (element.title))));
    })))));
}, {
    List: FooterList_js_1.FooterList,
    Item: FooterItem_js_1.FooterItem,
    Separator: FooterSeparator_js_1.FooterSeparator,
});
exports.default = exports.Footer;
